export default __webpack_public_path__ + "static/media/card.1b2f14c6.svg";